import { PrimaryControlsStripLeading } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { ToolbarViewButton } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { useScopedPathname } from "@-/com.npmjs.expo-router";
import {
  ToolbarActionsLane,
  ToolbarMoreActions,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.icon";
import { PrimaryControlsStripAccordion } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";
import { PrimaryControlsStripExpansionDisplayPushButton } from "@-/dev.improve.haniverse.routes.nav.app._components.primary-controls-strip.expansion.push-button.display";
import { useLearningStatsToolbarNavigation } from "#use-learning-stats-toolbar-navigation";

// Characters and Words are not tabs: Overall's progress surface switches between cards,
// characters and words itself.
export type LearningStatsTab = "overall" | "sentences";

// Sentences stays routable but is not offered as a tab until sentence-level tracking exists: a
// tab that only says "coming soon" reads as unfinished to App Review (guideline 2.1).
const TOOLBAR_TABS: readonly { label: string; value: LearningStatsTab }[] = [
  { label: "Overall", value: "overall" },
];

function pathnameToSelectedTab(pathname: string): LearningStatsTab {
  if (pathname.includes("/stats/sentences")) {
    return "sentences";
  }
  return "overall";
}

export function LearningStatsToolbar() {
  const pathname = useScopedPathname("/stats");
  const selectedTab = pathnameToSelectedTab(pathname);
  const onSelectTab = useLearningStatsToolbarNavigation();

  return (
    <PrimaryControlsStripAccordion
      actions={
        <ToolbarActionsLane>
          <PrimaryControlsStripLeading>
            <ToolbarMoreActions>
              <PrimaryControlsStripExpansionDisplayPushButton label="Display" />
            </ToolbarMoreActions>
          </PrimaryControlsStripLeading>
        </ToolbarActionsLane>
      }
    >
      {TOOLBAR_TABS.map((tab) => (
        <ToolbarViewButton
          key={tab.value}
          label={tab.label}
          onPress={() => onSelectTab(tab.value)}
          selected={tab.value === selectedTab}
        />
      ))}
    </PrimaryControlsStripAccordion>
  );
}
